module.exports = __webpack_public_path__ + "static/Clothes4All-Beach-EN_with-descriptions-4a2ba8a0aa0be69f170a719689d0e5f4.mp4";